import { FeatureFlagList, FeatureFlags } from "@/types/FeatureFlags";

export type BackendState = {
  online: boolean;
  featureFlags: FeatureFlagList;
};

export const INITIAL_STATE: BackendState = {
  online: true,
  featureFlags: {
    [FeatureFlags.inheritNowCrossSelling]: false,
  },
};

export enum ActionType {
  SET_STATE = "SET_STATE",
}

export type ACTION = { type: ActionType.SET_STATE; payload: BackendState };
